import { useBarcode } from 'next-barcode';

//Doc: https://confluence.optym.net/display/CONROUTEMAX/Enhancement+of+Loading+Guide+for+Client-Specific+Customization

const BarCode = ({ value, options, text }) => {
  const defaultOptions = {
    displayValue: true,
    format: "CODE128", //setting it to CODE128 although it is the default value
    height: 30,
    textPosition: "bottom", //default bottom
    textAlign: "center",
    textMargin: 2,
    fontSize: 14,
    fontOptions: "bold",
    margin: 1, // Set the space margin around the barcode
    marginTop: 4,
  };
  const { inputRef } = useBarcode({
    value,
    options: { ...defaultOptions, ...options, ...(text && { text }) },
  });
  return <canvas ref={inputRef} />;
};

export default BarCode;
